export default __webpack_public_path__ + "static/15-e333c5e76f480f39647b879973e3b376.jpg";